<template>
<section class="events__area pt-115 pb-120 p-relative">
   <div class="events__shape">
      <img class="events-1-shape" src="../../assets/img/events/events-shape.png" alt="">
    </div>
      <div class="container">
         <div class="row">
            <div class="col-xxl-4 offset-xxl-4">
               <div class="section__title-wrapper mb-60 text-center">
                  <h2 class="section__title">Online <span class="yellow-bg yellow-bg-big">Programlar<img src="../../assets/img/shape/yellow-bg.png" alt=""></span></h2>
                  <p>Size özel hazırlanmış online programlarımız</p>
               </div>
            </div>
         </div>
         <div class="row">
            <div v-for="event in events" :key="event.id" class="col-xxl-10 offset-xxl-1 col-xl-10 offset-xl-1 col-lg-10 offset-lg-1">
               <div class="events__item mb-10 hover__active">
                  <div class="events__item-inner d-flex align-items-center white-bg">
                     <div class="events__image">
                        <img :src="event.image" :alt="event.title">
                     </div>
                     <div class="events__content">
                        <h3 class="events__title">{{ event.title }}</h3>
                        <p>{{ event.description }}</p>
                        <div class="events__more text-center">
                           <a :href="event.buttonUrl" target="_blank" class="e-btn">
                              {{ event.buttonText }}
                              <i class="far fa-arrow-right"></i>
                           </a>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
         </div>
      </div>
   </section>
</template>

<script>
import { jsonService } from '@/services/jsonService'

export default {
   name: 'EventsSection',
   data() {
      return {
         events: []
      }
   },
   async created() {
      const events = await jsonService.getEvents()
      this.events = events.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt))
   }
}
</script>

<style scoped>
.events__item {
   transition: all 0.3s ease;
}

.events__item:hover {
   box-shadow: 0 10px 30px rgba(0,0,0,0.1);
}

.events__item-inner {
   padding: 30px;
   border-radius: 10px;
   border: 1px solid #edeef3;
}

.events__image {
   width: 400px;
   min-width: 400px;
   margin-right: 40px;
}

.events__image img {
   width: 100%;
   height: 400px;
   object-fit: cover;
   border-radius: 10px;
}

.events__content {
   flex: 1;
   display: flex;
   flex-direction: column;
   align-items: flex-start;
   min-height: 250px;
}

.events__title {
   font-size: 24px;
   font-weight: 600;
   margin-bottom: 20px;
   color: #0e1133;
}

.events__content p {
   color: #666;
   margin-bottom: 20px;
   white-space: pre-line;
   line-height: 1.6;
}

.events__more {
   width: 100%;
   margin-top: auto;
   text-align: center;
}

.e-btn {
   display: inline-flex;
   align-items: center;
   justify-content: center;
   padding: 15px 35px;
   background: #00c853;
   color: #fff;
   border-radius: 4px;
   text-decoration: none;
   font-weight: 600;
   text-transform: capitalize;
   transition: all 0.3s ease;
}

.e-btn:hover {
   background: #00a844;
   transform: translateY(-3px);
}

.e-btn i {
   display: none;
}

@media (max-width: 991px) {
   .events__item-inner {
      flex-direction: column;
      padding: 20px;
   }
   
   .events__image {
      width: 300px;
      min-width: auto;
      margin: 0 auto 20px auto;
   }

   .events__image img {
      width: 300px;
      height: 300px;
      object-fit: cover;
   }
   
   .events__content {
      text-align: center;
      align-items: center;
      min-height: 200px;
   }
   .e-btn {
      font-size: 12px;
   }
}
</style>
